export default __webpack_public_path__ + "static/media/100dc.af6dcd04.svg";